// offer.js

import { baseURL } from 'utils/api'
import Dictionary from '../dictionary'
import axios from 'axios'

const { offer } = Dictionary

const offerServies = {
  view: async (paramsObj) => {
    return axios.get(baseURL + offer.list(), { params: paramsObj })
  },
  add: async (data) => {
    return axios.post(baseURL + offer.create(), data)
  },
  delete: async (id, paramsObj) => {
    return axios.put(baseURL + offer.update(id), paramsObj)
  },
  edit: async (id, data) => {
    return axios.put(baseURL + offer.update(id), data)
  },
  getDetailById: async (id) => {
    return axios.get(baseURL + offer.getById(id))
  },  
  merchantOfferLocations: async (id,paramsObj) => {
    return axios.get(baseURL + offer.merchantOfferLocations(id), { params: paramsObj })
  },
  merchantOfferDetail: async (id,paramsObj) => {
    return axios.get(baseURL + offer.merchantOfferDetail(id), { params: paramsObj })
  },
}
export default offerServies